import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor() { }

  logInfo(msg: any)
  {
    console.info(msg);
  }

  logError(msg: any)
  {
    console.error(msg);
  }

  logWarn(msg: any)
  {
    console.warn(msg);
  }
}
